import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';

/* Feature Modules */
import { BeneWidgetComponent } from './components/app-component/app.component';
import { BeneFormComponent } from './components/bene-form/bene-form.component';
import { BeneFormPersonComponent } from './components/bene-form/bene-form.person.component/bene-form.person.component';
import { BeneFormChildrenComponent } from './components/bene-form/bene-form.children.component/bene-form.children.component';
import { BeneFormEstateComponent } from './components/bene-form/bene-form.estate.component/bene-form.estate.component';
import { BeneFormOtherTrustComponent } from './components/bene-form/bene-form.other-trust.component/bene-form.other-trust.component';
import { BeneListComponent } from './components/bene-list/bene-list.component';
import { BeneListService } from './services/beneList.service';
import { CustodianComponent } from './components/custodian/custodian-component';
import { PrintFormComponent } from './components/print-form/print-form.component';
import { ModalComponent } from './components/modal/modal.component';
import { ModalService } from './services/modal.service';
import { ModalChildRatiosComponent } from './components/modal-child-ratios/modal-child-ratios.component';
import { ModalRouteService } from './services/modal-route.service';
import { CommonModule } from '@angular/common';
import { AmorphicService } from '../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { WindowService } from '../../../angular-shared/services/window/window.service';
import { WidgetCommonModule } from '../../common/common.module';
import { ValidatorService } from '../../../angular-shared/services/validators-reactive.service';

// add all new bene components
import { CustodianComponentCoverPath } from './components/custodian/coverpath/custodian-component.coverpath';
import { CustodianComponentMMDirect } from './components/custodian/mmdirect/custodian-component.mmdirect';

import { BeneFormChildrenComponentCoverPath } from './components/bene-form/bene-form.children.component/coverpath/bene-form.children.component.coverpath';
import { BeneFormChildrenComponentMMDirect } from './components/bene-form/bene-form.children.component/mmdirect/bene-form.children.component.mmdirect';

import { BeneFormOtherTrustComponentCoverPath } from './components/bene-form/bene-form.other-trust.component/coverpath/bene-form.other-trust.component.coverpath';
import { BeneFormOtherTrustComponentMMDirect } from './components/bene-form/bene-form.other-trust.component/mmdirect/bene-form.other-trust.component.mmdirect';

import { BeneFormPersonComponentCoverPath } from './components/bene-form/bene-form.person.component/coverpath/bene-form.person.component.coverpath';
import { BeneFormPersonComponentMMDirect } from './components/bene-form/bene-form.person.component/mmdirect/bene-form.person.component.mmdirect';

import { BeneFormComponentCoverPath } from './components/bene-form/coverpath/bene-form.component.coverpath';
import { BeneFormComponentMMDirect } from './components/bene-form/mmdirect/bene-form.component.mmdirect';

import { BaseFormModule } from '../../../../coverpath-common/angular/components/form/base-form.module';
import { BeneListComponentCoverpath } from './components/bene-list/coverpath/bene-list.component.coverpath';
import { BeneListComponentMMDirect } from './components/bene-list/mmdirect/bene-list.component.mmdirect';
import { SharedModule } from '../../../../coverpath-common/angular/components/shared/shared.module';
import { LoadingModule } from '../../../../coverpath-common/angular/components/shared/loading/loading.module';
import { SpinnerModule } from '../../../../coverpath-common/angular/components/shared/spinner/spinner.module';
export const HavenEntryComponents = [
  BeneFormPersonComponent,
  BeneFormChildrenComponent,
  BeneFormEstateComponent,
  BeneFormOtherTrustComponent,
  CustodianComponent,
];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    BaseFormModule,
    TextMaskModule,
    WidgetCommonModule,
    SharedModule,
    LoadingModule,
    SpinnerModule,
  ],
  declarations: [
    BeneWidgetComponent,
    ModalComponent,
    ModalChildRatiosComponent,
    BeneFormComponent,
    BeneListComponent,
    BeneFormPersonComponent,
    BeneFormChildrenComponent,
    BeneFormEstateComponent,
    BeneFormOtherTrustComponent,
    PrintFormComponent,
    CustodianComponent,
    CustodianComponentCoverPath,
    CustodianComponentMMDirect,
    BeneFormChildrenComponentCoverPath,
    BeneFormChildrenComponentMMDirect,
    BeneFormOtherTrustComponentCoverPath,
    BeneFormOtherTrustComponentMMDirect,
    BeneFormPersonComponentCoverPath,
    BeneFormPersonComponentMMDirect,
    BeneFormComponentCoverPath,
    BeneFormComponentMMDirect,
    BeneListComponentCoverpath,
    BeneListComponentMMDirect,
  ],
  exports: [
    BeneWidgetComponent,
    ModalComponent,
    ModalChildRatiosComponent,
    BeneFormComponent,
    BeneListComponent,
    BeneFormPersonComponent,
    BeneFormChildrenComponent,
    BeneFormEstateComponent,
    BeneFormOtherTrustComponent,
    PrintFormComponent,
    CustodianComponent,
    CustodianComponentCoverPath,
    CustodianComponentMMDirect,
    BeneFormChildrenComponentCoverPath,
    BeneFormChildrenComponentMMDirect,
    BeneFormOtherTrustComponentCoverPath,
    BeneFormOtherTrustComponentMMDirect,
    BeneFormPersonComponentCoverPath,
    BeneFormPersonComponentMMDirect,
    BeneFormComponentCoverPath,
    BeneFormComponentMMDirect,
    BeneListComponentCoverpath,
    BeneListComponentMMDirect,
  ],
  entryComponents: [
    BeneFormPersonComponent,
    BeneFormChildrenComponent,
    BeneFormEstateComponent,
    BeneFormOtherTrustComponent,
    CustodianComponent,
    CustodianComponentCoverPath,
    CustodianComponentMMDirect,
    BeneFormChildrenComponentCoverPath,
    BeneFormChildrenComponentMMDirect,
    BeneFormOtherTrustComponentCoverPath,
    BeneFormOtherTrustComponentMMDirect,
    BeneFormPersonComponentCoverPath,
    BeneFormPersonComponentMMDirect,
    BeneFormComponentCoverPath,
    BeneFormComponentMMDirect,
    BeneListComponentCoverpath,
    BeneListComponentMMDirect,
  ],
  providers: [BeneListService, ValidatorService, ModalService, ModalRouteService, AmorphicService, WindowService],
  bootstrap: [BeneWidgetComponent],
})
export class BeneModule {}
